import { render } from "./CustomerOverview.vue?vue&type=template&id=42811ce6&scoped=true"
import script from "./CustomerOverview.vue?vue&type=script&lang=js"
export * from "./CustomerOverview.vue?vue&type=script&lang=js"

import "./CustomerOverview.vue?vue&type=style&index=0&id=42811ce6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42811ce6"]])

export default __exports__